import { render, staticRenderFns } from "./PendingModal.vue?vue&type=template&id=130a9075"
import script from "./PendingModal.vue?vue&type=script&lang=js"
export * from "./PendingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports